export default "__VITE_ASSET__CZBc66kg__"